import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasTitle()
    .make();

schema.prop('type').setType(String).setValue('text');
schema.prop('category').setType(String);
schema.prop('value').setType(String);

export default schema;
